import React, { useState, useEffect } from 'react'
import { Redirect, useLocation, useHistory } from 'react-router-dom'
import { ThemeProvider } from '@material-ui/core'
import PropTypes from 'prop-types'
import qs from 'query-string'

import {
  DialogExportRipds,
  DialogTrainingPlatform,
  Permitted,
  RegulationAcceptanceDialog,
} from 'components'
import { ContentMain, ScreenLoading } from './components'

import DrawerProvider from 'providers/DrawerProvider'

import useAuth from 'hooks/useAuth'
import useCustomTheme from 'hooks/useCustomTheme'
import useSnackbar from 'hooks/useSnackbar'
import useRegulations from 'hooks/useRegulations'

import { RIPD_INCITE_EXPORTED } from 'service/constants'
import { routes } from 'Routes'
import * as service from 'service'
import constants from 'constants/index'

const Main = ({
  permission,
  somePermissions,
  admin,
  children,
  showBackToFirstSteps,
  reduceMargin,
}) => {
  const auth = useAuth()
  const history = useHistory()
  const location = useLocation()
  const snackbar = useSnackbar()
  const { customTheme } = useCustomTheme()
  const { regulationVersions, isLoading, isAccept, hasError } = useRegulations()

  const showInciteRipd =
    auth.userCompany?.showInciteRipd &&
    !localStorage.getItem(RIPD_INCITE_EXPORTED + auth?.userCompany?.id)

  const search = qs.parse(location.search)

  const [dialogExportRipds, setDialogExportRipds] = useState(
    search.exportRipds === 'true',
  )
  const [ripdInciteOpen, setRipdInciteOpen] = useState(false)
  const [dialogTomcicket, setDialogTomcicket] = useState(false)
  const [dialogAcademy, setDialogAcademy] = useState(false)

  const handleExternalRedirect = (url) => {
    window.open(url, '_blank')
    history.replace(window.location.pathname)
  }

  const isTrial =
    auth?.company?.statusId === constants.userCompanies.TRIAL_LIMITED_STATUS
  const redirectTrial = () => {
    history.push(routes.myLgpd)
    return auth.setFreeTrialBlock(true)
  }

  const redirectToMoodle = () => {
    if (isTrial) return redirectTrial()
    setDialogAcademy(true)
    history.replace(window.location.pathname)
  }

  const handleMoodleRedirect = async () => {
    try {
      const response = await service.dponet.moodleLotus.generateKey()
      window.open(response?.data?.loginurl, '_blank')
    } catch {
      snackbar.open({
        message:
          'Não foi possível redirecionar para a plataforma, entre em contato conosco para verificar se você possui uma conta de acesso',
        variant: 'error',
      })
    }
  }

  const redirectToMoodleDocuments = async () => {
    if (isTrial) return redirectTrial()
    const wantsUrl = 'https://educacao.dponet.com.br/mod/folder/view.php?id=189'
    try {
      const response = await service.dponet.moodleLotus.generateKey()
      window.open(`${response?.data?.loginurl}&wantsurl=${wantsUrl}`, '_blank')
    } catch {
      snackbar.open({
        message:
          'Não foi possível redirecionar para a plataforma, entre em contato conosco para verificar se você possui uma conta de acesso',
        variant: 'error',
      })
    } finally {
      history.replace()
    }
  }

  const handleOpenTomticketDialog = () => setDialogTomcicket(true)

  useEffect(() => {
    if (search.redirectToMoodle === 'true') redirectToMoodle()
    //eslint-disable-next-line
  }, [search.redirectToMoodle])

  useEffect(() => {
    if (search.redirectToCommunity === 'true')
      handleExternalRedirect(constants.community.COMMUNITY_TARGET_URL)
    //eslint-disable-next-line
  }, [search.redirectToCommunity])

  useEffect(() => {
    if (search.redirectToPrivacyUniversity === 'true')
      handleExternalRedirect(
        constants.privacyUniversity.PRIVACY_UNIVERSITY_TARGET_URL,
      )
    //eslint-disable-next-line
  }, [search.redirectToPrivacyUniversity])

  useEffect(() => {
    if (search.redirectToMoodleDocuments === 'true') redirectToMoodleDocuments()
    //eslint-disable-next-line
  }, [search.redirectToMoodleDocuments])

  useEffect(() => {
    setDialogExportRipds(search.exportRipds === 'true')

    // eslint-disable-next-line
  }, [search.exportRipds])

  useEffect(() => {
    setRipdInciteOpen(showInciteRipd)

    // eslint-disable-next-line
  }, [showInciteRipd])

  return (
    <DrawerProvider>
      <ThemeProvider theme={customTheme}>
        <ScreenLoading loaded={auth.loaded}>
          <Permitted
            someTags={somePermissions}
            tag={permission}
            admin={admin}
            fallback={<Redirect to={routes.forbidden} />}
          >
            <ContentMain
              children={children}
              showBackToFirstSteps={showBackToFirstSteps}
              reduceMargin={reduceMargin}
              company={auth?.userCompany?.company}
              handleOpenTomticketDialog={handleOpenTomticketDialog}
              dialogTomcicket={dialogTomcicket}
              setDialogTomcicket={setDialogTomcicket}
            />
          </Permitted>
          <DialogExportRipds
            open={dialogExportRipds}
            setOpen={setDialogExportRipds}
          />
          <DialogExportRipds
            open={ripdInciteOpen}
            setOpen={setRipdInciteOpen}
            ripdIncite
          />
          {dialogAcademy && (
            <DialogTrainingPlatform
              open={dialogAcademy}
              onClose={() => setDialogAcademy(false)}
              onMoodle={handleMoodleRedirect}
            />
          )}
          {!isLoading && !isAccept && (
            <RegulationAcceptanceDialog
              open={Boolean(regulationVersions?.[0]) && !hasError}
            />
          )}
        </ScreenLoading>
      </ThemeProvider>
    </DrawerProvider>
  )
}

Main.propTypes = {
  permission: PropTypes.string,
  showBackToFirstSteps: PropTypes.bool,
  reduceMargin: PropTypes.bool,
}

export default Main
